import { DialogTitle, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Close from '@mui/icons-material/Close';

interface Props {
  title: string;
  subtitle?: React.ReactNode;
  onClose: () => void;
  centerOnMobile?: boolean;
}

export const ModalHeader = ({ title, subtitle, onClose }: Props) => {
  return (
    <StyledDialogTitle>
      <CloseRow>
        <StyledCloseButton aria-label="Close" onClick={onClose} size="small">
          <StyledCloseIcon aria-hidden />
        </StyledCloseButton>
      </CloseRow>
      <TitleBlock>
        <StyledTitle variant="h3" fontWeight={600}>
          {title}
        </StyledTitle>
        {subtitle !== null && subtitle !== undefined && subtitle !== '' && (
          <StyledSubtitle variant="body2" color="text.secondary">
            {subtitle}
          </StyledSubtitle>
        )}
      </TitleBlock>
    </StyledDialogTitle>
  );
};

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  paddingBottom: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
}));

const CloseRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  marginBottom: theme.spacing(1),
  marginTop: -theme.spacing(0.5),
  marginRight: -theme.spacing(0.5),
}));

const TitleBlock = styled('div')({
  textAlign: 'center',
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  display: 'block',
  fontSize: theme.typography.h3.fontSize,
}));

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  display: 'block',
  marginTop: theme.spacing(1),
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: 360,
  whiteSpace: 'pre-line',
}));

const StyledCloseButton = styled(IconButton)({
  flexShrink: 0,
});

const StyledCloseIcon = styled(Close)({
  fontSize: 20,
});
